module.exports = __webpack_public_path__ + "labioplastika_11_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/labioplastika_11_before_tn.jpg
// module id = 1534
// module chunks = 0